import type { PlatformRole } from "@eca/shared";
import { Outlet } from "react-router";
import { NotFoundPage } from "@/pages/not-found";
import { useMe } from "@/lib/session";

/** Screens for some roles only. Others get the not-found page, matching the API's refusal. */
export function RequireRole({ roles }: { roles: PlatformRole[] }) {
  const role = useMe().data?.user.platformRole;
  return role && roles.includes(role) ? <Outlet /> : <NotFoundPage />;
}
